import React from "react";
import "./DoctorDatapoint.css";

function DoctorDatapoint({ label, data }) {
  return (
    <div className="ddElement">
      <p className="ddContent">{`${label}:`}</p>
      <p className="ddData">{data}</p>
    </div>
  );
}

export default DoctorDatapoint;
